import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Music, Loader2, ArrowLeft, CheckCircle } from "lucide-react";
import { motion } from "framer-motion";
import axios from "axios";

const API = `/api`;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Une erreur est survenue');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#FAF9F6] flex items-center justify-center px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="bg-white rounded-3xl shadow-[0_10px_60px_rgba(44,53,49,0.06)] border border-[#EBE7E0] p-8 sm:p-10 w-full max-w-md"
      >
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-[#6B8576] rounded-3xl flex items-center justify-center mx-auto mb-5">
            <Music className="w-7 h-7 text-white" strokeWidth={1.5} />
          </div>
          <h1 className="text-2xl font-semibold text-[#2C3531]" style={{ fontFamily: 'Outfit' }}>Mot de passe oublié</h1>
          <p className="text-[#6A7771] text-sm mt-1.5">Entrez votre adresse email pour recevoir un lien de réinitialisation</p>
        </div>

        {sent ? (
          <div className="text-center py-4" data-testid="forgot-success">
            <CheckCircle className="w-12 h-12 text-[#6B8576] mx-auto mb-4" strokeWidth={1.5} />
            <p className="text-[#2C3531] font-medium mb-2">Email envoyé !</p>
            <p className="text-sm text-[#6A7771] leading-relaxed">Si un compte existe avec cette adresse, vous recevrez un lien de réinitialisation. Pensez à vérifier vos spams.</p>
            <Link to="/login" className="inline-flex items-center gap-1.5 text-[#6B8576] font-medium text-sm mt-6 hover:underline">
              <ArrowLeft className="w-4 h-4" strokeWidth={1.5} /> Retour à la connexion
            </Link>
          </div>
        ) : (
          <>
            {error && <div className="bg-red-50 text-[#B86666] p-3.5 rounded-2xl text-sm mb-5 border border-red-100" data-testid="forgot-error">{error}</div>}
            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="block text-sm font-medium text-[#2C3531] mb-1.5">Email</label>
                <input type="email" className="w-full px-4 py-3 rounded-2xl border border-[#EBE7E0] bg-[#FAF9F6] focus:outline-none focus:ring-2 focus:ring-[#6B8576]/20 focus:border-[#6B8576] transition-all duration-300" value={email} onChange={e => setEmail(e.target.value)} required data-testid="forgot-email" placeholder="votre@email.com" />
              </div>
              <button type="submit" disabled={loading} className="w-full py-3 bg-[#6B8576] text-white rounded-full font-medium hover:bg-[#546A5E] transition-all duration-300 disabled:opacity-50 text-sm" data-testid="forgot-submit">
                {loading ? <Loader2 className="w-5 h-5 animate-spin mx-auto" /> : 'Envoyer le lien'}
              </button>
            </form>
            <p className="text-center text-sm text-[#6A7771] mt-7">
              <Link to="/login" className="text-[#6B8576] font-medium hover:underline flex items-center justify-center gap-1.5">
                <ArrowLeft className="w-4 h-4" strokeWidth={1.5} /> Retour à la connexion
              </Link>
            </p>
          </>
        )}
      </motion.div>
    </div>
  );
}
